export default {"src":"/_next/static/image/public/images/ic_records_blue.2fb5fedd0f1e43825bcdbc27b0632ec0.svg","height":17,"width":13};